import { OfferCardActionButtons } from "./offer-card-action-buttons";
import { OfferCardFare } from "./offer-card-fare";
import React from "react";

import { useTranslation } from "react-i18next";
import {
  Button,
  CaretIcon,
  RepeatIcon,
} from "../../../../../shared/infrastructure";
import { OfferT, OfferViewT } from "../../../domain";

type DetailsLayoutProps = {
  offer: OfferT;
  toggleView: () => void;
  view: OfferViewT;
  tableViewIsOpen?: boolean;
  toggleTable?: () => void;
  showDetails: boolean;
  toggleDetails: () => void;
};

export const OfferCardDetails = ({
  offer,
  toggleView,
  tableViewIsOpen,
  showDetails,
  toggleDetails,
  toggleTable,
  view,
}: DetailsLayoutProps): React.ReactElement => {
  const [t] = useTranslation("global");

  return (
    <section
      className={[
        showDetails ? "flex" : "hidden lg:flex",
        "h-full cursor-pointer flex-col justify-between pb-[5px] text-sm font-[400] hover:text-black",
      ].join(" ")}
    >
      <section
        className={[
          showDetails ? "flex flex-col md:hidden lg:grid" : "hidden lg:grid",
          "px-4 lg:grid-rows-[1fr_auto] lg:gap-[10px] lg:px-0",
        ].join(" ")}
      >
        <OfferCardFare offer={offer} />
        {offer.type === "single" && (
          <section className="hidden max-w-[102px] xl:mb-0 xl:grid xl:!max-w-none xl:grid-flow-col xl:grid-cols-[1fr_1fr] xl:gap-[10px]">
            {view === "rep" && (
              <Button
                className="w-full md:hidden xl:flex"
                appearance="secondary"
                endIcon={
                  <CaretIcon
                    fill="#919191"
                    className={tableViewIsOpen ? "rotate-180" : ""}
                  />
                }
                onClick={toggleTable}
              >
                {tableViewIsOpen
                  ? t<string>(
                      "context.private.components.offer-card-details.buttons.show-less"
                    )
                  : t<string>(
                      "context.private.components.offer-card-details.buttons.show-more"
                    )}
              </Button>
            )}
            {view === "offer" && <span></span>}
            <Button
              className="w-full md:hidden xl:flex"
              endIcon={<RepeatIcon fill="white" />}
              onClick={toggleView}
            >
              {view === "offer"
                ? t<string>(
                    "context.private.components.offer-card-details.buttons.rep-view"
                  )
                : t<string>(
                    "context.private.components.offer-card-details.buttons.offer-view"
                  )}
            </Button>
          </section>
        )}
      </section>
      <OfferCardActionButtons
        offer={offer}
        showDetails={showDetails}
        toggleDetails={toggleDetails}
        toggleTable={toggleTable}
        toggleView={toggleView}
        view={view}
        tableViewIsOpen={tableViewIsOpen}
      />
    </section>
  );
};
